<template>
  <div class="page adminpage">

    

    <div class="app-overlay addproduct-overlay" v-if="openOverlayAddproduct">
        <div class="app-overlay-inner">
          <div class="app-overlay-close" v-on:click=" openOverlayAddproduct = false">&times;</div>
            <div class="overlay-header">
            <h2>Produkt hinzufügen</h2>
            </div>
            <div class="overlay-body">
                <add-product :products="products" @closeOverlay="openOverlayProducts = false"></add-product>
             </div>
        </div>
    </div>

    <div class="product-header">
        <div class="p-meta">
         <h1>Produkte editieren</h1>

         <div class="actions">
           <a><i class="icon icon-projects"></i><span>Produkte</span></a>
           <a><i class="icon icon-user"></i><span>User</span></a>

         </div>
        </div>

    </div>

    <div class="columns max flex wrap">
        <div class="column">
          
          <div class="flex-group">
            <h3>Produkte</h3>
            <a v-on:click="addProduct" href="#!" class="addProduct"><i class="icon icon-plus" ></i>Produkt hinzufügen</a>
          </div>

          <div class="product-list" >
              <div class="product" v-for="(product, i) in products" :key="i" :class="product.attributes.active ? 'published' : 'unpublished'">
                <div class="pro-col product-name"><router-link :to="{ name: 'Product', params: { articlenumber: product.articlenumber }}">{{product.articlenumber}}</router-link></div>
                <div class="pro-col created">{{ product.created }}</div>
                <div class="pro-col">{{ $store.state.products.saved.success ? ( $store.state.products.saved.data.id == product.id ? ' last saved' : '') : ''  }} </div>
                <div class="pro-col"><router-link :to="{ name: 'Product', params: { articlenumber: product.articlenumber }}"><i class="icon icon-edit"></i></router-link></div>
              </div>
          </div>
          
        </div>

    </div>
  </div>
</template>
<script>
  import AddProduct from '../components/AddProduct'

  export default {
    name: 'ProductsAdminPage',
    components: {
       AddProduct,
      },
    data () { 
      return {
        openOverlayAddproduct: false,
      }
    },
    computed: {
        user () {
            return this.$store.state.authentication.user
        },
        products () {
            return this.$store.state.products.all
        },      
    },
    created(){
        this.$store.dispatch('products/getAll');
        //console.log( this.$store.state.products.saved );
    },

    methods: {
       closeOverlay(){
        this.$emit('closeOverlay')
      },
      addProduct(e){
          //console.log('addProduct');
          e.preventDefault();
          this.openOverlayAddproduct = true;
       },

    },
  }

</script>
<style></style>